import { capitalize, first, get, pick } from 'lodash'

import { IBaseAddress } from '../../types'

export type TAddressItem = IBaseAddress & {
  companyNumber?: string
  branche?: string
  representation?: string
  lonlat?: string[]
  ref1?: string
  ref2?: string
  ref3?: string
  reference?: string
  id?: number
  highlightedId?: number
  prename?: string
  surname?: string
  phone1?: string
  mail?: string
  eori?: string
  ustid?: string
  addressHint?: string
}

type TReturnGetAddress = Partial<TAddressItem>

export const contactAddressFields = [
  'prename',
  'surname',
  'phone1',
  'mail',
  'eori',
  'ustid',
  'addressHint',
]

export const relevantAddressFields = [
  'name1',
  'name2',
  'name3',
  'street',
  'streetNumber',
  'streetNumberAddition',
  'zip',
  'city',
  'country',
  'ref1',
  'ref2',
  'ref3',
  'lonlat',
  'id',
  'highlightedId',
  ...contactAddressFields,
]

export const getAddress = (
  address: object,
  prefix?: string,
): TReturnGetAddress => {
  if (prefix) {
    const result = {}
    relevantAddressFields.forEach((field) => {
      result[field] = get(
        address,
        `${prefix}${capitalize(first(field))}${field.substring(1)}`,
      )
    })
    return result
  }
  return pick(address, relevantAddressFields)
}

// senderName1 => name1
export const unprefixAddress = (
  address: object,
  prefix: string,
): TReturnGetAddress => {
  return getAddress(address, prefix)
}

// name1 => senderName1
export const prefixAddress = (
  address: TAddressItem,
  prefix: string,
): TReturnGetAddress => {
  if (prefix) {
    const result = {}
    relevantAddressFields.forEach((field) => {
      result[`${prefix}${capitalize(first(field))}${field.substring(1)}`] = get(
        address,
        field,
      )
    })
    return result
  }
  return pick(address, relevantAddressFields)
}

export const getFromGermanAddress = (
  address: object | null | undefined,
): TReturnGetAddress | undefined => {
  if (!address) return undefined
  return {
    name1: get(address, 'Name1'),
    name2: get(address, 'Name2'),
    name3: get(address, 'Name3'),
    street: get(address, 'Strasse'),
    streetNumber: get(address, 'Strassenr'),
    streetNumberAddition: get(address, 'Strassenrzusatz'),
    zip: get(address, 'Postleitzahl'),
    city: get(address, 'Ort'),
    country: get(address, 'Land'),
  }
}
